<template>
    <div class="c-author-posts" v-if="ready">
        <div class="u-label">
            <!-- <i class="el-icon-notebook-2"></i> -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.092 512.092" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M396.784 446.553L266.011 115.886a10.667 10.667 0 00-8.661-6.656L54.683 85.38c-5.752-.808-11.07 3.2-11.878 8.952-.018.13-.034.261-.048.392L.091 436.057c-.763 5.841 3.353 11.196 9.194 11.959.085.011.171.021.256.03l373.333 42.667h1.216a10.667 10.667 0 0010.667-9.664l2.773-29.589a10.635 10.635 0 00-.746-4.907z" fill="#ffa000"/><path d="M469.424 94.724c-.684-5.851-5.983-10.04-11.834-9.355l-.092.011-91.733 10.795-270.933 31.871c-5.801.659-9.994 5.86-9.408 11.669l32 341.333a10.667 10.667 0 0010.667 9.664h1.216l373.333-42.667c5.853-.671 10.053-5.96 9.382-11.813a6.114 6.114 0 00-.016-.134L469.424 94.724z" fill="#ffe082"/><path d="M309.424 170.713a10.667 10.667 0 01-7.552-18.219l53.333-53.333c4.093-4.237 10.845-4.355 15.083-.262 4.237 4.093 4.354 10.845.262 15.083-.086.089-.173.176-.262.262l-53.333 53.333a10.664 10.664 0 01-7.531 3.136z" fill="#455a64"/><circle cx="394.758" cy="74.713" r="53.333" fill="#f44336"/></svg>
            <span>最新作品</span>
            <a :href="uid | authorLink" class="u-more" target="_blank"
                ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 426.667 426.667" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="42.667" cy="213.333" r="42.667"/><circle cx="213.333" cy="213.333" r="42.667"/><circle cx="384" cy="213.333" r="42.667"/></svg></a>
        </div>

        <ul class="u-list" v-if="data && data.length">
            <li v-for="(item, i) in data" :key="i">
                <a class="u-item" :href="url(item.ID, item.post_type)" target="_blank">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:class="'u-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M286.187 268.435L112.968 441.677c-6.875 6.876-18.021 6.876-24.897.001L45.214 398.82c-6.874-6.874-6.875-18.02-.001-24.894l117.914-117.939-69.122-69.122-48.79-48.79c-6.875-6.875-6.875-18.021 0-24.896l42.857-42.857c6.875-6.875 18.021-6.875 24.896 0l116.543 116.543 56.675 56.675c6.874 6.874 6.875 18.02.001 24.895z" fill="#00d8de"/><path d="M230.853 188.261L163.1 256.014l-25.897-25.897-43.197-43.252-48.79-48.79c-6.875-6.875-6.875-18.021 0-24.896L88.07 70.325c6.876-6.876 18.025-6.875 24.899.003l91.987 92.035 25.897 25.898z" fill="#00a5ff"/><path fill="#0087ff" d="M230.853 188.261L163.1 256.014l-16.43-16.457 67.752-67.753z"/><path d="M466.786 268.435L293.568 441.677c-6.875 6.876-18.022 6.876-24.897.001l-42.858-42.858c-6.874-6.874-6.875-18.02-.001-24.894l117.914-117.939-69.122-69.122-48.79-48.79c-6.875-6.875-6.875-18.021 0-24.896l42.857-42.857c6.875-6.875 18.021-6.875 24.896 0L410.11 186.865l56.675 56.675c6.875 6.874 6.875 18.02.001 24.895z" fill="#00a5ff"/><path d="M411.452 188.261l-67.753 67.753-25.897-25.897-43.197-43.252-48.79-48.79c-6.875-6.875-6.875-18.021 0-24.896l42.854-42.854c6.876-6.876 18.025-6.875 24.899.003l91.987 92.035 25.897 25.898z" fill="#00d8de"/><g fill="#05c1c1"><path d="M411.452 188.261l-67.753 67.753-16.43-16.457 67.753-67.753zM494.01 488.583a7.5 7.5 0 00-7.5 7.5v8.417c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-8.417a7.5 7.5 0 00-7.5-7.5zM449.738 488.583a7.5 7.5 0 00-7.5 7.5v8.417c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-8.417a7.5 7.5 0 00-7.5-7.5zM405.466 488.583a7.5 7.5 0 00-7.5 7.5v8.417c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-8.417a7.5 7.5 0 00-7.5-7.5z"/></g><g fill="#0087ff"><path d="M106.534 23.417a7.5 7.5 0 007.5-7.5V7.5a7.5 7.5 0 00-15 0v8.417a7.5 7.5 0 007.5 7.5zM62.262 23.417a7.5 7.5 0 007.5-7.5V7.5a7.5 7.5 0 00-15 0v8.417a7.5 7.5 0 007.5 7.5zM17.99 0a7.5 7.5 0 00-7.5 7.5v8.417a7.5 7.5 0 0015 0V7.5a7.5 7.5 0 00-7.5-7.5z"/></g></svg>
                        {{ item.post_title || item.post_type + "/无标题" }}
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { authorLink, getLink } from "@jx3box/jx3box-common/js/utils";
import { getUserPosts } from "../../service/author";
export default {
    name: "AuthorPosts",
    props: ["uid"],
    data: function () {
        return {
            data: [],
        };
    },
    computed: {
        ready: function () {
            return this.uid && this.data && this.data.length;
        },
    },
    watch: {
        uid: {
            immediate: true,
            handler: function (val) {
                val && this.init();
            },
        },
    },
    methods: {
        url: function (pid, type) {
            return getLink(type, pid);
        },
        init: function () {
            getUserPosts(this.uid)
                .then((data) => {
                    this.data = data.slice(0, 5);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    filters: {
        authorLink,
    },
};
</script>

<style lang="less">
.c-author-posts {
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    li {
        .db;
    }
    .u-item {
        .db;
        padding: 3px 2px;
        .nobreak;
        .fz(12px,2);
        color: #666;
        border-bottom: 1px solid transparent;
        &:hover {
            color: @pink;
            // background-color:#fff;
            // border-bottom: 1px solid @border;
            .u-icon{
                transform: translateX(5px);
            }
        }
    }
    .u-icon {
        .fz(12px);
        .size(12px);
        // .y;
        color: #999;
        // .mr(5px);
        transition: all 0.3s;
    }

    .u-label {
        .pr;
        .u-more {
            .fz(12px);
            .pa;
            .rb(0,10px);
            color: #999;
            &:hover {
                color: @pink;
            }
        }
    }
}
</style>
